import styled from "styled-components";

export const Styles = styled.div`
  &.should_hidden_unit {
    .ant-input-group-addon {
      display: none;
    }
  }
  div.ant-row.ant-form-item-row
    > div.ant-col.ant-form-item-control
    > div:nth-child(2)
    > div:nth-child(2) {
    height: 0 !important;
  }
`;
